import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationText } from '@/components/i18n/TranslationText';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
export function Footer() {
  const {
    t
  } = useTranslation();
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 py-12">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div className="col-span-1 md:col-span-2">
            <img src="/lovable-uploads/b39387ca-08fc-4e1c-a0f7-79c2fa0f4845.png" alt="Subtrackr Logo" className="h-8 mb-4" />
            <p className="text-muted-foreground mb-4 max-w-md">
              <TranslationText i18nKey="footer.description">
                Subtrackr helps businesses take control of their contracts with powerful management tools, reminders, and analytics.
              </TranslationText>
            </p>
            <div className="flex space-x-4">
              <Button variant="ghost" size="icon" aria-label="LinkedIn" className="rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </Button>
              <Button variant="ghost" size="icon" aria-label="Twitter" className="rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </Button>
            </div>
          </div>
          
          {/* Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">
              <TranslationText i18nKey="footer.product">Product</TranslationText>
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">
                  <TranslationText i18nKey="footer.features">Features</TranslationText>
                </a>
              </li>
              
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                  <TranslationText i18nKey="footer.security">Security</TranslationText>
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">
              <TranslationText i18nKey="footer.company">Company</TranslationText>
            </h3>
            <ul className="space-y-2">
              
              
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground transition-colors">
                  <TranslationText i18nKey="footer.privacy">Privacy Policy</TranslationText>
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-muted-foreground hover:text-foreground transition-colors">
                  <TranslationText i18nKey="footer.terms">Terms of Service</TranslationText>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            <TranslationText i18nKey="footer.copyright" values={{
            year: currentYear
          }}>
              © {currentYear} Subtrackr. All rights reserved.
            </TranslationText>
          </p>
          <div className="flex mt-4 md:mt-0 space-x-4">
            <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              <TranslationText i18nKey="footer.privacy">Privacy Policy</TranslationText>
            </Link>
            <Link to="/terms-of-service" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              <TranslationText i18nKey="footer.terms">Terms of Service</TranslationText>
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}